import React, {useEffect, useState} from "react";
import cn from "classnames";
import styles from "./Search01.module.sass";
import Icon from "../../components/Icon";
import Card from "../../components/Card";
import Dropdown from "../../components/Dropdown";
import {get, prepareItems} from "../../adapters/api";
import {fromWei} from "web3-utils";
import {Slider} from 'antd';
import Loader from "../../components/Loader";
import config from '../../config'

const tokensAgeOptions = ["By publishing date", "Newest", "Oldest"];
const priceOptions = ["By token price", "Cheapest", "Most Expensive"];
const videoOptions = ["Token media type", "Short fims", "Music", "Movies", "Images"];

const searchQuery = new URLSearchParams(window.location.search).get("searchQuery") || '';

const Search = () => {
  const [activeIndex, setActiveIndex] = useState(false);
  const [showFilterSlider, setShowFilterSlider] = useState(true);
  const [tokensAge, setTokensAge] = useState(tokensAgeOptions[1]); // filter by tokens age
  const [priceDD, setPriceDD] = useState(priceOptions[0]); // filter by price dropdown
  const [videoDD, setVideoDD] = useState(videoOptions[0]); // filter by video dropdown
  const [search, setSearch] = useState(searchQuery); // field value
  const [searchField, setSearchField] = useState(searchQuery); // filter by query word
  const [priceRange, setPriceRange] = useState();
  const [data, setData] = useState(false); // resp from backend
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(false);
  const [searchInCat, setSearchInCat] = useState('All'); //filter by category
  const [searchFilters, setSearchFilters] = useState(); //trigger for useEffect
  const [selectedPriceMin, setSelectedPriceMin] = useState(false); //trigger for useEffect
  const [selectedPriceMax, setSelectedPriceMax] = useState(false); //trigger for useEffect
  const [loadMoreInProcess, setLoadMoreInProcess] = useState(false);
  const [hasMorePages, setHasMorePages] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchField(search);
    return false;
  };

  const STEP = 0.1;

  const handleMore = () => {
    setMore(true);
    setPage(page + 1)
  }

  useEffect(() => {
    const fl = {page};

    if (searchField.length) fl.searchQuery = searchField;
    if (tokensAge !== tokensAgeOptions[0]) fl.tokensAge = tokensAge;
    if (priceDD !== priceOptions[0]) fl.priceDD = priceDD;
    if (videoDD !== videoOptions[0]) fl.typeContent = videoDD;
    if (searchInCat !== 'All') fl.searchInCat = searchInCat;
    if (priceRange) fl.priceRange = priceRange;
    setSearchFilters(fl);

  }, [priceDD, videoDD, tokensAge, searchInCat, searchField, priceRange, page])

  //fix to new search params
  useEffect(() => {
    (async () => {
      if (searchFilters) {
        setLoadMoreInProcess(true);
        const params = prepareParams();

        const info = await get('token/discover?' + params);
        console.log('discover', info);
        if (info.data) {
          info.data.items = prepareItems(info.data.items, info.data.users);
          if (more) {
            info.data.items = data.items ? data.items.concat(info.data.items) : info.data.items;
            setMore(false);
          }
          info.data.filters.minPrice = Math.floor(info.data.filters.minPrice ? fromWei(`${info.data.filters.minPrice}0000000000`, 'ether') : 0);
          info.data.filters.maxPrice = Math.ceil(info.data.filters.maxPrice ? fromWei(`${info.data.filters.maxPrice}0000000000`, 'ether') : 1);
          setData(info.data);
          if (!selectedPriceMin) setSelectedPriceMin(info.data.filters.minPrice);
          if (!selectedPriceMax) setSelectedPriceMax(info.data.filters.maxPrice);
          setLoadMoreInProcess(false);
          setHasMorePages(info.data.filters.hasMorePages);
        }
      }
    })();
  }, [searchFilters])

  const prepareParams = () => {
    return new URLSearchParams(searchFilters).toString();
  };

  function onRangeChange(value) {
    setSelectedPriceMin(value[0]);
    setSelectedPriceMax(value[1]);
  }

  function onRangeAfterChange(value) {
    setPriceRange(value);
  }

  const handleAgeChange = (val) => {
    setTokensAge(val);
    setPriceDD(priceOptions[0]);
  }

  const handlePriceDD = (val) => {
    setTokensAge(tokensAgeOptions[0]);
    setPriceDD(val);
  }

  const handleVideoDD = (val) => {
    setVideoDD(val);
  }

  const handleResetFilters = () => {
    setTokensAge(tokensAgeOptions[0]);
    setPriceDD(priceOptions[0]);
    setSelectedPriceMin(data.filters.minPrice);
    setSelectedPriceMax(data.filters.maxPrice);
    setSearchInCat('All');
    setSearchField('');
    setPage(1);
    setActiveIndex(false);
    setPriceRange([data.filters.minPrice, data.filters.maxPrice]);
    setShowFilterSlider(false);
    setTimeout(() => {
      setShowFilterSlider(true);
    }, 0);
  }

  return (
    <div className={cn("section-pt80", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={styles.title}>Type your keywords</div>
          <form
            className={styles.search}
            action=""
            onSubmit={handleSubmit}
          >
            <input
              className={styles.input}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              name="search"
              placeholder="Search ..."
            />
            <button className={styles.result}>
              <Icon name="search" size="16"/>
            </button>
          </form>
        </div>
        <div className={styles.sorting}>
          <div className={styles.nav}>
            <button className={cn(styles.link, {[styles.active]: searchInCat === 'All',})} onClick={() => {
              setActiveIndex(false);
              setSearchInCat('All')
            }}>All
            </button>
            {data && data.categories.map((x, index) => (
              <button
                className={cn(styles.link, {
                  [styles.active]: index === activeIndex,
                })}
                onClick={() => {
                  setActiveIndex(index);
                  setSearchInCat(x.category)
                }}
                key={index}
              >
                {x.category}
              </button>
            ))}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.filters}>
            <div className={styles.range}>
              <div className={styles.label}>Price range</div>
              <div>
                {data && showFilterSlider && <Slider
                  range
                  min={parseFloat(data.filters.minPrice)}
                  max={parseFloat(data.filters.maxPrice)}
                  step={STEP}
                  defaultValue={[data.filters.minPrice, data.filters.maxPrice]}
                  onChange={onRangeChange}
                  onAfterChange={onRangeAfterChange}
                />}
              </div>

              <div className={styles.scale}>
                <div
                  className={styles.number}>{selectedPriceMin}&nbsp;{config.symbolName}</div>
                <div
                  className={styles.number}>{selectedPriceMax}&nbsp;{config.symbolName}</div>
              </div>
            </div>
            <div className={styles.group}>
              <div className={styles.item}>
                <div className={styles.label}>Sort by</div>
                <Dropdown
                  className={styles.dropdown}
                  value={tokensAge}
                  setValue={handleAgeChange}
                  options={tokensAgeOptions}
                />
              </div>
              <div className={styles.dropdown}>
                <div className={styles.label}>or</div>
                <Dropdown
                  className={styles.dropdown}
                  value={priceDD}
                  setValue={handlePriceDD}
                  options={priceOptions}
                />
              </div>

              <hr className="hr_dark" />
              
              <div className={styles.dropdown}>
                <div className={styles.label}>Filter by</div>
                <Dropdown
                  className={styles.dropdown}
                  value={videoDD}
                  setValue={handleVideoDD}
                  options={videoOptions}
                />
              </div>

            </div>
            <div className={styles.reset}>
              {data &&
              <a className={styles.reset} onClick={handleResetFilters}>
                <Icon name="close-circle-fill" size="24"/>
                <span>Reset filter</span></a>
              }
            </div>
          </div>
          <div className={styles.wrapper}>
            <div className={styles.list}>
              {data && data.items.map((x, index) => (
                <Card className={styles.card} item={x} key={index} users={data.users}/>
              ))}
            </div>
            <div className={styles.btns}>
              {hasMorePages && !loadMoreInProcess &&
              <button className={cn("button-stroke", styles.button)} onClick={handleMore}>
                <span>Load more</span>
              </button>
              }
              {loadMoreInProcess && <Loader className={styles.loader}/>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
